module.exports = __webpack_public_path__ + "static/Profile_AndersBjorlin-f2481e7bfdfae5b16434d319104fadf8.jpg";